import { useEffect, useState } from "react"
import { useParams } from "react-router-dom"
import { getCourseTopics } from "../../api/axios"
import { Box, Container, Typography, styled, Divider} from "@mui/material"
import RoadmapPlayToggle from "../../components/RoadmapPlayToggle"
import Playground from "../../components/Playground"
import TopicRoadmap from "../../components/TopicRoadmap"

const CustomTypography = styled(Typography) (({theme}) => ({
    background: 'linear-gradient(316.91deg, #A29EDA -26.21%, #B292D1 -10.9%, #B557AF 64.77%, #6B3A8F 94.98%, #5D2A79 115.46%)',
    WebkitBackgroundClip: 'text',
    WebkitTextFillColor: 'transparent',
    textShadow: '2px 2px 4px rgba(0,0,0,0.3)',
    fontWeight: 'bold'
}))

const Topics = () => {
    const [topicData, setTopicData] = useState([])
    const [view, setView] = useState('roadmap')
    const {idCourse} = useParams()

    const data = JSON.parse(localStorage.getItem("course") || {courseName: ""})

    useEffect(() => {
        const fetchCourseTopics = async () => {
            try {
                const response = await getCourseTopics(idCourse)
                setTopicData(response.data)
            } catch (error) {
                console.error(`Error getting topics: ${error}`)
            }
        }
        fetchCourseTopics()
    }, [idCourse])


    return (
        <Box sx={{
            height: '100%',
            width: '100%',
            paddingLeft: '10%',
            paddingTop: '2%',
            display: "flex"
        }}>
            <Container>
                <Typography variant="h4" sx={{color: '#E1E1E6'}}>
                    {data.courseName}
                </Typography>
                <Box sx={{
                    width:'100%',
                    height: '85%',
                    marginTop: '5%',
                    position: 'relative',
                    background: 'linear-gradient(144.47deg, #1D151D 42.84%, #4E2D33 179.39%)',
                    borderRadius: '24px',
                    zIndex: 1,

                    "&::before": {
                        content: '""',
                        position: "absolute",
                        inset: 0, // Covers the entire box
                        borderRadius: "24px", // Ensures rounded corners
                        padding: "3px", // Thickness of the border
                        background: "linear-gradient(316.91deg, #A29EDA -26.21%, #B292D1 -10.9%, #B557AF 38.67%, #6B3A8F 78.77%, #5D2A79 115.46%)", 
              
                        // Masks the inner part, leaving only the border
                        WebkitMask: "linear-gradient(white 0 0) content-box, linear-gradient(white 0 0)",
                        WebkitMaskComposite: "destination-out",
                        maskComposite: "exclude",
              
                        zIndex: -1,
                    }
                    
                }}>
                    <Box sx={{
                        display: "flex",
                        justifyContent: 'space-between',
                        padding: '5%'
                    }}>
                        <CustomTypography variant="h6">
                            Course Description
                        </CustomTypography>
                        <RoadmapPlayToggle view={view} setView={setView} />
                    </Box>
                    <Box sx={{
                        width: '95%',
                        height: '75%',
                        paddingLeft: '5%',
                        color: 'white'
                    }}>
                        <Divider sx={{width: '90%', border: '1px solid white', marginLeft: '2%'}}/>
                        {view === 'roadmap' ? <TopicRoadmap topicData={topicData}/> : <Playground topicData={topicData}/>}
                    </Box>

                </Box>
            </Container>
            <Container sx={{width: '50%'}}>
            </Container>
        </Box>
        
    )
    
}

export default Topics